interface BadgeProps {
    startAdornment?: React.ReactNode
    label: string
}
export const Badge = ({startAdornment, label}: BadgeProps) => {
    if (label === '') {
        return null
    }
    return (
        <div className="flex flex-row gap-2 items-center p-1 px-2 rounded-lg bg-inverse-tertiary">
            {startAdornment}
            <p className="text-sm font-bold">{label}</p>
        </div>
    )
}